import React, { useEffect, useState } from 'react'
import {
  Container,
  Nav,
  Navbar,
  Col,
  Row,
  Button,
  Form,
  FormControl,
  InputGroup,
  Modal,
  Dropdown,
  SplitButton,
  FormSelect
} from "react-bootstrap";
import { NavLink, Link } from "react-router-dom";
import TutorSideMenu from "./TutorSideMenu";
import Countdown from 'react-countdown';
import { FecthData } from '../../Services/FetchData';
import Session1 from '../Session/Session1';
import { School } from '../../Services/School';
import { NotificationManager } from 'react-notifications';
import { Student } from '../../Services/Student';
import _ from 'lodash';
import TutorSessionCalendar from './TutorSessionCalendar';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { Auth } from '../../Services/Auth';
import { divideTimeRangeToSession, formatDate, getMaskedText, slotDateFormat, timeFormate, utcToTzDate } from '../../helpers/utils';
import TimeSelect from '../common/TimeSelect';
import ActionButton from '../ActionButton';
import NotificationUI from '../common/NotificationUI';
import moment from 'moment-timezone';
import { cancelSession, getResourceUrl } from '../../Services/CommanFunctions';

function TutorDashboard() {
  const user = JSON.parse(localStorage.getItem('user'))
  const history = useHistory()
  const selectedDay = val => {
    selectDate(formatDate(val))
  };
  const [sessions, setSessions] = useState([])
  const [students, setStudents] = useState([])
  const [dateWiseSessions, setDateWiseSessions] = useState([])
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [show1, setShow1] = useState(false);
  const handleClose1 = () => setShow1(false);
  const handleShow1 = () => setShow1(true);
  const [selectedDate, selectDate] = useState(formatDate(new Date()))
  const [subject, setSubject] = useState([]);
  const [grade, setGrade] = useState([]);
  const [error, setError] = useState()
  const [isSchedule,setIsSchedule]=useState(false)
  const [timePeriod,setTimePeriod]=useState(30)
  const [slots,setSlots]=useState([])
  const [selectedSlots,selectSlots]=useState([])
  const [inputSlot, setInputSlot] = useState([
    { recurring_option: '', date: '', subject: '', grade_id: '', start_time: "10:00", end_time: '11:00', type_of_tutoring_session: '', tutor_id: user?.tutor?._id }
  ])
  const day = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
  const handleChange = (index, event) => {
    // setValue(event.target.name,event.target.value) 
    let data = [...inputSlot];
    data[index][event.target.name] = event.target.value;
    setInputSlot(data);
    // if (inputSlot[index].subject != '' && inputSlot[index].type_of_tutoring_session != '') {
      //   getTutorSession(index, inputSlot[index].subject, user?.student?.grade_id, inputSlot[index].type_of_tutoring_session)
      // }
    }
  const submitFormData = (e) => {
    e.preventDefault();
    School.post({ tutor_id: user?.tutor?._id, slot: inputSlot,isSchedule:isSchedule,scheduleSlots:selectedSlots }, 'tutor/tutor_add_session').then(
      (data) => {
        if (data.error === 0) {
          // if(isSchedule){
          //   data?.data?.map(msg=>NotificationManager.success(msg.message, 'success!', 2000))
          // }
          NotificationManager.success(data.message, 'success!', 2000);
          getTutorSession()
          handleClose1()
          //setMessage(data.message)
          // nextStep()
          //  localStorage.setItem('student_subject', JSON.stringify(data.data))
          // history.push('/tutor');
        }


      },
      (error) => {
        NotificationManager.error(error.toString(), 'error!', 2000);
        // setError(error.toString())
      }
    )
  }

  const date = Date.now() + 2000000;
  const getTutorSession = () => {
    FecthData.getData('tutor/get_tutor_session/' + user?.tutor?._id+"?upcoming="+true+'&limit='+true ).then(
      (data) => {
          setSessions(data?.data)
      }
    )
  }
  const getTutorSessionDateWise = () => {
    FecthData.getData('tutor/get_tutor_session/' + user?.tutor?._id+'?date='+selectedDate ).then(
      (data) => {
        setDateWiseSessions(data?.data)
      }
    )
  }
  const cancelTutorSession=(session_id,cancelled_by)=>{
    cancelSession(session_id,cancelled_by).then(()=>{
      getTutorSession()
    })
  }
  useEffect(() => {
    getTutorSession()
    School.post({ 'tutor_id': user?.tutor?._id }, 'tutor/get_tutor_selected_subject').then(
      (data) => {
        if (data.error === 0) {
          setSubject(data.data)
        }

      },
      (error) => {
        NotificationManager.error(error.toString(), 'error!', 2000);
        // setError(error.toString())
      }
    )
    Student.getDta({ page: 0 }, 'grades/get_all_grade').then(
      (data) => setGrade(data?.data),
      (error) => setError(error.toString())
    );
    FecthData.postJsonData({ tutor_id: user?.tutor?._id }, 'tutor/get_tutor_student').then(
      (data) => {
        const std = () => {
          var list = []
          data?.data?.map(item => {
            // if (item.document.student_details[0])
            list.push(item.document.student_details[0])
          })
          return list
        }
        setStudents(std())
      }
    )
  }, [])
  const getDateWiseSession = () => {
    if (selectedDate) {
      const tutorSessions = _.filter(sessions, session => {
        if (session.date == new Date(selectedDate).toISOString()) {
          return session
        }
      })
      setDateWiseSessions(tutorSessions)
    }
  }
  useEffect(() => {
    getTutorSessionDateWise()
  }, [selectedDate])
  useEffect(() => {
    if(isSchedule)
      setSlots(divideTimeRangeToSession(inputSlot[0].start_time,inputSlot[0].end_time,timePeriod))
    else{
      selectSlots([])
      setSlots([])
    }
    
  }, [timePeriod,isSchedule,inputSlot[0].start_time,inputSlot[0].end_time])
  const logout = () => {
    localStorage.clear()
    history.push('/tutor')
  }
  const selectSlot=(index,e,slot)=>{
    let slotArr=[...selectedSlots]
    console.log(e.target.checked,index,slot)
    if(e.target.checked)
      slotArr.push(slot)
    else
    _.remove(slotArr,sl=>_.isEqual(sl, slot))
  selectSlots(slotArr)
  }
    return (
    <>
      <section style={{ height: '100%', width: 'auto' }}>
        <div className="dashboard-wrap">
          <TutorSideMenu />
          <div className="middle">
            <Row>
              <Col md={12}>
                <Form.Group className="form-group mb-2">
                  <Form.Control type="text" placeholder="Search" className="search-input" />
                  <Button variant="primary" type="submit" className="search-btn">
                    <img src="images/search-icon.png" alt="" width="22" />
                  </Button>
                </Form.Group>
                <div className="mt-4">
                  <h2 className="text-muted mb-0">Welcome back {user?.name}! </h2>
                  <h6 className="text-muted mt-3 d-flex justify-content-between">UPCOMING SESSIONS <a className="text-muted" href="javascript:void(0)"><small>View All</small></a></h6>
                </div>
              </Col>
              {sessions?.map(session => <Col md={4}>
                <div className="dash-box-tutor">
                  <img src={`images/tutor-bg1.jpg`} alt="" />
                  <div className="remaining-hrs">
                    <Countdown
                      date={session?.start_time}
                      daysInHours="true"
                    />
                  </div>
                  <div className="tutor-user">
                    {session?.status&& session?.status=='cancelled'?<h4 >{session?.status}</h4>
                    :<h4 style={{cursor:'pointer'}} onClick={()=>cancelTutorSession(session?._id,user?._id)}>{session?.status?session?.status:'cancel'}</h4>}
                    {/* <div className="tutor-user-img">
                      <img src="images/avatar2.png" alt="" />
                    </div>
                    <h4>ID: 567876</h4>
                    <p>8th Grade</p> */}
                  </div>
                  <div className="dash-box-text">
                    {/* <h4>Functions & Graphing</h4> */}
                    <p>{session.subject.title.toUpperCase()}</p>
                    <p><small>{utcToTzDate(session?.date,'ddd MMM DD')}  |  {timeFormate(session?.start_time)}-{timeFormate(session?.end_time)} </small></p>
                  </div>
                </div>
              </Col> 
              )}
              {/* <Col md={4}>
                <div className="dash-box-tutor">
                  <img src="images/tutor-bg2.jpg" alt="" />
                  <div className="remaining-hrs">
                    <Countdown
                      date={date}
                      daysInHours="true"
                    />
                  </div>
                  <div className="tutor-user">
                    <div className="tutor-user-img">
                      <img src="images/avatar2.png" alt="" />
                    </div>
                    <h4>ID: 567876</h4>
                    <p>8th Grade</p>
                  </div>
                  <div className="dash-box-text">
                    <h4>Functions & Graphing</h4>
                    <p>ALGEBRA</p>
                    <p><small>Monday, Aug 06   | {timeFormate('8:00')}-9:00AM </small></p>
                  </div>
                </div>
              </Col>
              <Col md={4}>
                <div className="dash-box-tutor">
                  <img src="images/tutor-bg3.jpg" alt="" />
                  <div className="remaining-hrs">
                    <Countdown
                      date={date}
                      daysInHours="true"
                    />
                  </div>
                  <div className="tutor-user">
                    <div className="tutor-user-img">
                      <img src="images/avatar2.png" alt="" />
                    </div>
                    <h4>ID: 567876</h4>
                    <p>8th Grade</p>
                  </div>
                  <div className="dash-box-text">
                    <h4>Functions & Graphing</h4>
                    <p>ALGEBRA</p>
                    <p><small>Monday, Aug 06   |   8:00AM-9:00AM </small></p>
                  </div>
                </div>
              </Col> */}
              <Col md={4}>
                <div className="dash-box-tutor dash-box-text-blank" onClick={handleShow1}>
                  <img src="images/add-icon.png" alt="" width="30%" />
                  <h4 className="text-muted">Add Session</h4>
                </div>
                <div></div>
                <div></div>
              </Col>
              {/* <Col md={12}>
                <h6 className="text-muted mt-3 d-flex justify-content-between">My Students <a className="text-muted" href="javascript:void(0)"><small>View All</small></a></h6>
              </Col>
              <Col md={12}>
                <div className="student-list">
                  <ul>
                    {students.map(student => <li>
                      <Link to={{ pathname: "/tutor-student-detail", state: student }}>
                        <div className="tutor-user">
                          <div className="tutor-user-img">
                            <img src="images/avatar2.png" alt="" />
                          </div>
                          <h4>{getMaskedText(student?.first_name,'name')}</h4>
                          <p>8th Grade</p>
                        </div>
                        <div className="online-status active"></div>
                      </Link>
                    </li>)}
                    {/* <li>
                      <Link to="/tutor-student-detail">
                        <div className="tutor-user">
                          <div className="tutor-user-img">
                            <img src="images/avatar1.png" alt="" />
                          </div>
                          <h4>346789</h4>
                          <p>8th Grade</p>
                        </div>
                        <div className="online-status active"></div>
                      </Link>
                    </li>
                    <li>
                      <Link to="/tutor-student-detail">
                        <div className="tutor-user">
                          <div className="tutor-user-img">
                            <img src="images/avatar3.png" alt="" />
                          </div>
                          <h4>187726</h4>
                          <p>8th Grade</p>
                        </div>
                        <div className="online-status active"></div>
                      </Link>
                    </li>
                    <li>
                      <Link to="/tutor-student-detail">
                        <div className="tutor-user">
                          <div className="tutor-user-img">
                            <img src="images/avatar2.png" alt="" />
                          </div>
                          <h4>567876</h4>
                          <p>8th Grade</p>
                        </div>
                        <div className="online-status active"></div>
                      </Link>
                    </li>
                    <li>
                      <Link to="/tutor-student-detail">
                        <div className="tutor-user">
                          <div className="tutor-user-img">
                            <img src="images/avatar1.png" alt="" />
                          </div>
                          <h4>346789</h4>
                          <p>8th Grade</p>
                        </div>
                        <div className="online-status active"></div>
                      </Link>
                    </li>
                    <li>
                      <Link to="/tutor-student-detail">
                        <div className="tutor-user">
                          <div className="tutor-user-img">
                            <img src="images/avatar3.png" alt="" />
                          </div>
                          <h4>187726</h4>
                          <p>8th Grade</p>
                        </div>
                        <div className="online-status active"></div>
                      </Link>
                    </li>
                    <li>
                      <Link to="/tutor-student-detail">
                        <div className="tutor-user">
                          <div className="tutor-user-img">
                            <img src="images/avatar2.png" alt="" />
                          </div>
                          <h4>ID: 567876</h4>
                          <p>8th Grade</p>
                        </div>
                        <div className="online-status active"></div>
                      </Link>
                    </li> *
                  </ul>
                </div>
              </Col> */}
              {/* <Col md={12}>
                <h6 className="text-muted my-3 d-flex justify-content-between">Request Received <a className="text-muted" href="javascript:void(0)"><small>View All</small></a></h6>
              </Col>
              <Col md={12}>
                <div className="tutor-list">
                  <a href="javascript:void(0)" className="tutor-item" onClick={handleShow}>
                    <div className="tutor-wrap">
                      <div className="tutor-avatar">
                        <img src="images/avatar2.png" alt="" />
                      </div>
                      <div className="tutor-subject">
                        <h6>Sandra D.</h6>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. </p>
                      </div>
                    </div>
                  </a>
                  <a href="javascript:void(0)" className="tutor-item" onClick={handleShow}>
                    <div className="tutor-wrap">
                      <div className="tutor-avatar">
                        <img src="images/avatar1.png" alt="" />
                      </div>
                      <div className="tutor-subject">
                        <h6>Andy F.</h6>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. </p>
                      </div>
                    </div>
                  </a>
                </div>
              </Col> */}
            </Row>
          </div>
          <div className="right">
            <div className="user-short-text">
              <NotificationUI/>
              {/* <div className="notification-bell">
                <img src="images/bell-icon.png" alt="" width="32" />
                <div className="noti-dot"></div>
              </div> */}
              <div className="user-short-profile">
                <div className="user-avatar">
                  <img src={user?.propic?getResourceUrl(user?.propic):"default_logos/no_profile_img.png"} width={'100%'} height={'100%'} alt="" />
                </div>
                <div className="user-short-name">
                  <h5>{user?.name} - {user?.tutor?.org_type == 'school' ? user?.tutor_profile?.school_name : user?.tutor_profile?.company_name}</h5>
                  <p><small>ID: {user?.tutor?.tutor_code}</small></p>
                </div>
                <Dropdown >
                  <Dropdown.Toggle drop='none' variant="">

                  </Dropdown.Toggle >
                  <Dropdown.Menu>
                    <Dropdown.Item onClick={logout}
                    // href="#/action"
                    >Logout</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
                {/* <div className="drop-down">
                  <img src="images/drop-icon.png" alt="" width="10" />
                </div> */}
              </div>
            </div>
            <TutorSessionCalendar dateWiseSessions={dateWiseSessions} selectedDay={selectedDay} />

          </div>
        </div>
      </section>

      <Modal show={show1} onHide={handleClose1}
        size="md"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Add session</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={submitFormData}>
            <div className="modal-form">
              {inputSlot.map((element, index) => 
              
              <Row>
                <Form.Group className="form-group mb-3" as={Col} md="12">
                  <Form.Label className='p-1'> Subject </Form.Label>
                  <Form.Select name='subject' onChange={e => handleChange(index, e)}>
                    <option selected disabled>Select Subject*</option>
                    {subject.map(item => <option value={item._id}>{item.title}</option>)}
                    {/* <option value="1">Geometry</option>
                    <option value="2">Calculus</option>
                    <option value="3">Biology</option> */}
                  </Form.Select>
                </Form.Group>
                <Form.Group className="form-group mb-3" as={Col} md="12">
                  <Form.Label className='p-1'> Grades </Form.Label>
                  <Form.Select name='grade_id' onChange={e => handleChange(index, e)}>
                    <option selected disabled>Select Grade Preference*</option>
                    {grade.map(grd => <option value={grd._id}>{grd.title}</option>)}
                  </Form.Select>
                </Form.Group>
                <Form.Group className="form-group mb-3" as={Col} md="12">
                  <Form.Label className='p-1'> Session Type </Form.Label>
                  <Form.Select name='type_of_tutoring_session' onChange={e => handleChange(index, e)}>
                    <option selected disabled>Type of tutoring session*</option>
                    <option value="daily session">Daily session</option>
                    <option value="weekly session">Weekly session</option>
                    <option value="monthly session">Monthly session</option>
                  </Form.Select>
                </Form.Group>
                {/* <Form.Group className="form-group mb-3" as={Col} md="12">
                  <Form.Select name='session' onChange={e => handleChange(index, e)}>
                    <option>Type of session*</option>
                    <option value="2">Session 1</option>
                    <option value="2">Session 2</option>
                    <option value="3">Session 3</option>
                    <option value="4">Session 4</option>
                    <option value="5">Session 5</option>
                    <option value="6">Session 6</option>
                  </Form.Select>
                </Form.Group> */}
                <Form.Group className="form-group mb-3" as={Col} md="12">
                  <Form.Label className='p-1'> Date </Form.Label>
                  <Form.Control type="date" format="" min={formatDate(new Date())} placeholder="Select Date*" name='date'  onChange={e => handleChange(index, e)} defaultValue={new Date()} />
                </Form.Group>
                <Form.Group className="form-group mb-3" as={Col} md="6" >
                  <Form.Label className='p-1'> Start Time </Form.Label>
                  {/* <Form.Control type="time" placeholder="Start Time*" name='start_time' onChange={e => handleChange(index, e)} /> */}
                  <TimeSelect name="start_time" label='start time' index={index} onChange={handleChange} value={element?.start_time}/>
                </Form.Group>
                <Form.Group className="form-group mb-3" as={Col} md="6">
                  <Form.Label className='p-1'> End Time </Form.Label>
                  {/* <Form.Control type="time" placeholder="End Time*" name='end_time' onChange={e => handleChange(index, e)} /> */}
                  <TimeSelect name="end_time" label='end time' index={index} onChange={handleChange} value={element?.end_time}/>
                </Form.Group>
                <div className="mb-3 applyschedule">
                  <Form.Check
                    inline
                    label={`Apply schedule to all  ${element?.date ? moment(element?.date).format("dddd") : day[new Date().getDay()]}`}
                    name="recurring_option"
                    type="radio"
                    id="one"
                    value={element?.date ? day[new Date(element?.date).getDay()] : day[new Date().getDay()]}
                    onChange={e => handleChange(index, e)}
                  // checked
                  />
                  <Form.Check
                    inline
                    label={`Apply the schedule to ${element?.date ?
                     moment(element?.date).date()+' '+new Date(element?.date).toLocaleString('default', { month: 'long' }) 
                       : new Date().toLocaleString('default', { month: 'short', day: "2-digit" })}`}
                    name="recurring_option"
                    type="radio"
                    id="two"
                    value={element?.date ? new Date(element?.date).toLocaleString('default', { month: 'short', day: "2-digit" }) : new Date().toLocaleString('default', { month: 'short', day: "2-digit" })}
                    onChange={e => handleChange(index, e)}
                  />
                </div>
                <Col md="12" className="text-center mt-2">
                <Row className='align-items-center mb-3'>
              <Col md={6} className='align-items-center'><Form.Group className="form-group ">
                {/* <Form.Label className='p-1'>  </Form.Label> */}
                <Form.Check // prettier-ignore
        type="switch"
        onChange={(e)=>setIsSchedule(e.target.checked)}
        id="custom-switch"
        value={isSchedule}
        label="Schedule the session"
      />
                </Form.Group></Col>
                {isSchedule&&<Col md={6} className='align-items-center'>
                
                <Form.Group className="form-group " >
                  <Row className='justify-content-end align-items-center'>
                    <Col md={5}>
                    <Form.Label className=''> duration </Form.Label>
                    </Col>
                    <Col md={7}>
                    <FormSelect onChange={(e)=>setTimePeriod(e.target.value)} defaultValue={timePeriod}>
            <option value={30}>30 min</option>
            <option value={60}>1 hr</option>
          </FormSelect>
          </Col>
                  </Row>
                
         
      </Form.Group>
      </Col>}
                </Row>
                </Col>
                <div className="mb-3 applyschedule">
                  {slots?.map((slot,index1)=>
                  
                  <Form.Check
                    inline
                    // label={slot?.start_time +'-'+slot?.end_time}
                    label={slotDateFormat(slot?.start_time)+'-'+slotDateFormat(slot?.end_time)}
                    name="recurring_option"
                    type="checkbox"
                    value={''}
                    onChange={e => selectSlot(index1,e, slot)}
                  // checked
                  />)}
                </div>
                <Col md="12" className="text-center mt-2">
                <ActionButton className="btn px-4 btn-primary" title={'Submit'} type={'submit'} requiredFields={[element?.subject,element?.grade_id,element?.type_of_tutoring_session,element?.date,element?.start_time,element?.end_time,element?.recurring_option]}/>
                  {/* <Button  variant="primary" type='submit'>Submit</Button> */}
                </Col>
              </Row>)}
            </div>
          </Form>        </Modal.Body>
      </Modal>


      <Modal show={show} onHide={handleClose}
        size="md"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Connection Request From Student ID: 567876</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <div className="modal-form">
              <Row>
                <Col md="12">
                  <Form.Group className="form-group relative">
                    <Form.Control className="mb-3"
                      as="textarea"
                      value="Hi, I need help with linear equations, functions, & 
                    graphs. Can we schedule a tutoring session?"
                      style={{ height: '120px' }}
                    />
                    <div className="attachment">
                      {/* <div className="attach-file">
                      <input type="file" />
                      <i className="fa fa-paperclip" aria-hidden="true"></i>
                      <p>Attach File</p>
                    </div> */}
                      <div className="msg-btn">
                        <button className="btn btn-primary btn-pill btn-sm">DOWNLOAD ATTACHED FILES</button>
                      </div>
                    </div>
                  </Form.Group>
                </Col>
                <Form.Group className="form-group mb-3" as={Col} md="12">
                  <Form.Select>
                    <option selected>Algebra</option>
                    <option value="1">Geometry</option>
                    <option value="2">Calculus</option>
                    <option value="3">Biology</option>
                  </Form.Select>
                </Form.Group>
                <Form.Group className="form-group mb-3" as={Col} md="6">
                  <Form.Select>
                    <option>1:00 HR</option>
                    <option value="1">2:00 HR</option>
                    <option value="2">3:00 HR</option>
                    <option value="3">4:00 HR</option>
                  </Form.Select>
                </Form.Group>
                <Form.Group className="form-group mb-3" as={Col} md="6">
                  <Form.Select>
                    <option>Live Session</option>
                  </Form.Select>
                </Form.Group>
                <Form.Group className="form-group mb-3" as={Col} md="6">
                  <Form.Select>
                    <option>Start Time</option>
                    <option value="1" selected>10:00AM</option>
                    <option value="2">11:00AM</option>
                  </Form.Select>
                </Form.Group>
                <Form.Group className="form-group mb-3" as={Col} md="6">
                  <Form.Select>
                    <option>End Time</option>
                    <option value="1">10:00AM</option>
                    <option value="2" selected>11:00AM</option>
                  </Form.Select>
                </Form.Group>
                <Form.Group className="form-group mb-3" as={Col} md="12">
                  <Form.Select>
                    <option>Apply This Schedule To All Sundays</option>
                  </Form.Select>
                </Form.Group>
                <Col md="12" className="text-center mt-2">
                  <Button className="px-4 btn-pill me-2" variant="primary">Accept</Button>
                  <Button className="px-4 btn-pill ms-2" variant="secondary">Decline</Button>
                </Col>
              </Row>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

    </>
  )
}

export default TutorDashboard
